import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import SearchIcon from '@mui/icons-material/Search';
import {MdClose} from 'react-icons/md';
import {styled} from '@mui/material/styles';
import styles from './SearchBar.module.scss';

const CssInput = styled('input')(({theme}) => ({
	color: theme.palette.text.primary,
}));

const SearchBar = ({value = '', onChange, label, placeholder}) => {
	const [isInputInFocus, setisInputInFocus] = useState(null);

	return (
		<div
			className={clsx(
				styles.searchBarContainer,
				isInputInFocus && styles.inFocus,
			)}
		>
			<CssInput
				className={styles.input}
				value={value}
				onChange={e => onChange(e.target.value)}
				onFocus={() => setisInputInFocus(true)}
				onBlur={() => setisInputInFocus(false)}
				type="text"
				id="header-search"
				data-testid="header-search"
				autoComplete="off"
				aria-label={label}
				placeholder={placeholder}
			/>
			{value ? (
				<MdClose
					className={clsx(styles.icon, styles.clickable)}
					onClick={() => onChange('')}
				/>
			) : (
				<SearchIcon className={styles.icon} />
			)}
		</div>
	);
};

SearchBar.propTypes = {
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
};

export default SearchBar;
